export default function pickToolTipName(lookupObj) {
  const {
    displayName,
    domain,
    email,
    primaryIdentifier,
    secondaryIdentifier,
    src
  } = lookupObj;
  const display = displayName || email || domain || typeof primaryIdentifier !== 'number' && primaryIdentifier || secondaryIdentifier || src || undefined;
  return `${display}`;
}